import ProjectContainer from "../UI/ProjectContainer";
import picture from "../../images/imgCalender.png";
import FirstModal from "../Modal/FirstModal";
import UserForm from "../Form/UserForm";
import useUserData from "../Hooks/useUserData";

const HomePage = () => {
    const {isLoading,isUserAuthenticated,inputNeeded,isDuplicate , message } = useUserData();

    return (
        <ProjectContainer>
            <div className="flex  justify-center items-center min-w-full  h-full  ">
                <img src={picture} alt="عکس تقویم" width={150} height={170} />
            </div>
            <div className="min-w-full">
                <FirstModal isLoading={isLoading} isDuplicate={isDuplicate} message={message} />
                {!isUserAuthenticated && <UserForm  inputNeeded={inputNeeded} /> }
            </div>
        </ProjectContainer>
    )
}


export default HomePage;